import type { ISystemStatusAlerts, ISystemStatusAppAlerts, ISystemStatusData, ISystemStatusMonitoring, IUserDocumentsStatus } from '@/types';

export const useSystemStatusStore = defineStore('systemStatus', () => {
    const alerts = ref<ISystemStatusAlerts | null>(null);
    const appAlerts = ref<ISystemStatusAppAlerts | null>(null);
    const monitoring = ref<ISystemStatusMonitoring | null>(null);
    const userDocumentsStatus = ref<IUserDocumentsStatus | null>(null);

    // actions
    function setSystemStatus(data: ISystemStatusData) {
        if (data.alerts !== undefined) alerts.value = data.alerts;
        if (data.appalerts !== undefined) appAlerts.value = data.appalerts;
        if (data.monitoring !== undefined) monitoring.value = data.monitoring;
    }

    function setUserPersonalData(data: { userDocumentsStatus?: IUserDocumentsStatus }) {
        if (data.userDocumentsStatus !== undefined) userDocumentsStatus.value = data.userDocumentsStatus;
    }

    return {
        alerts,
        appAlerts,
        monitoring,
        userDocumentsStatus,
        setSystemStatus,
        setUserPersonalData,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSystemStatusStore, import.meta.hot));
}
